export const ensureAuthSuccess = (result) => {
    if (result instanceof Error) throw result;
    return result;
};
